module.exports = __webpack_public_path__ + "img/ameer-taweel.39049314.webp";